/**
 * Country flag SVG URLs for the countries facet-icon.tsx's COUNTRY_NAME_TO_ISO can resolve.
 *
 * Replaces a global `import 'flag-icons/css/flag-icons.min.css'`, which inlined all 271 flags as
 * data URIs (422KB, render-blocking) into every page that rendered the search panel. Each flag is
 * now its own ~0.2-1KB file (`no-inline` stops Vite base64-ing them into the JS chunk), fetched
 * only when a foreign-location row actually renders. Add an import here when adding a country to
 * COUNTRY_NAME_TO_ISO; facet-icon.test.ts fails if one is missing.
 */
import aeFlag from 'flag-icons/flags/4x3/ae.svg?url&no-inline';
import atFlag from 'flag-icons/flags/4x3/at.svg?url&no-inline';
import beFlag from 'flag-icons/flags/4x3/be.svg?url&no-inline';
import caFlag from 'flag-icons/flags/4x3/ca.svg?url&no-inline';
import chFlag from 'flag-icons/flags/4x3/ch.svg?url&no-inline';
import deFlag from 'flag-icons/flags/4x3/de.svg?url&no-inline';
import dkFlag from 'flag-icons/flags/4x3/dk.svg?url&no-inline';
import eeFlag from 'flag-icons/flags/4x3/ee.svg?url&no-inline';
import esFlag from 'flag-icons/flags/4x3/es.svg?url&no-inline';
import fiFlag from 'flag-icons/flags/4x3/fi.svg?url&no-inline';
import frFlag from 'flag-icons/flags/4x3/fr.svg?url&no-inline';
import gbFlag from 'flag-icons/flags/4x3/gb.svg?url&no-inline';
import ieFlag from 'flag-icons/flags/4x3/ie.svg?url&no-inline';
import inFlag from 'flag-icons/flags/4x3/in.svg?url&no-inline';
import itFlag from 'flag-icons/flags/4x3/it.svg?url&no-inline';
import ltFlag from 'flag-icons/flags/4x3/lt.svg?url&no-inline';
import lvFlag from 'flag-icons/flags/4x3/lv.svg?url&no-inline';
import nlFlag from 'flag-icons/flags/4x3/nl.svg?url&no-inline';
import noFlag from 'flag-icons/flags/4x3/no.svg?url&no-inline';
import plFlag from 'flag-icons/flags/4x3/pl.svg?url&no-inline';
import ptFlag from 'flag-icons/flags/4x3/pt.svg?url&no-inline';
import roFlag from 'flag-icons/flags/4x3/ro.svg?url&no-inline';
import seFlag from 'flag-icons/flags/4x3/se.svg?url&no-inline';
import uaFlag from 'flag-icons/flags/4x3/ua.svg?url&no-inline';
import usFlag from 'flag-icons/flags/4x3/us.svg?url&no-inline';

const COUNTRY_FLAG_URLS: Record<string, string> = {
  ae: aeFlag,
  at: atFlag,
  be: beFlag,
  ca: caFlag,
  ch: chFlag,
  de: deFlag,
  dk: dkFlag,
  ee: eeFlag,
  es: esFlag,
  fi: fiFlag,
  fr: frFlag,
  gb: gbFlag,
  ie: ieFlag,
  in: inFlag,
  it: itFlag,
  lt: ltFlag,
  lv: lvFlag,
  nl: nlFlag,
  no: noFlag,
  pl: plFlag,
  pt: ptFlag,
  ro: roFlag,
  se: seFlag,
  ua: uaFlag,
  us: usFlag,
};

/** Flag URL for an ISO 3166-1 alpha-2 code, or null when none is bundled (or stubbed out, as in
 * web-static's search-panel island build). */
export function getCountryFlagUrl(countryCode: string): string | null {
  return COUNTRY_FLAG_URLS[countryCode] || null;
}
